import { UserInterface } from '../../interfaces/user.interface'

export const getTwitterProfileHelper = (user?: UserInterface | null) => {
  if (user) {
    return user.profiles.find((p) => p.provider === 'twitter')
  }
  return undefined
}
